import {
  CREATE_BUSINESS_BREAK_OPERATION,
  DELETE_BUSINESS_BREAK_OPERATION,
  LIST_BUSINESS_BREAKS_OPERATION,
  UPDATE_BUSINESS_BREAK_OPERATION,
  type GeneratedBreakKind,
  type GeneratedCreateBusinessBreakRequest,
  type GeneratedCreateBusinessBreakResponse,
  type GeneratedListBusinessBreaksResponse,
  type GeneratedUpdateBusinessBreakRequest,
  type GeneratedUpdateBusinessBreakResponse,
} from './generated-business';
import { performAuthorizedRequest, replacePathParams } from './business-request';

export async function listBusinessBreaksRequest(
  token: string,
  businessId: number
): Promise<GeneratedListBusinessBreaksResponse> {
  return performAuthorizedRequest<GeneratedListBusinessBreaksResponse>(
    token,
    {
      ...LIST_BUSINESS_BREAKS_OPERATION,
      path: replacePathParams(LIST_BUSINESS_BREAKS_OPERATION.path, {
        business_id: businessId,
      }),
    },
    {
      networkErrorMessage:
        'Não foi possível obter as pausas. Verifique se o backend está disponível.',
      requestErrorMessage: 'Não foi possível carregar as pausas agora.',
    }
  );
}

export async function createBusinessBreakRequest(
  token: string,
  businessId: number,
  breakPayload: GeneratedCreateBusinessBreakRequest
): Promise<GeneratedCreateBusinessBreakResponse> {
  return performAuthorizedRequest<GeneratedCreateBusinessBreakResponse>(
    token,
    {
      ...CREATE_BUSINESS_BREAK_OPERATION,
      path: replacePathParams(CREATE_BUSINESS_BREAK_OPERATION.path, {
        business_id: businessId,
      }),
    },
    {
      body: breakPayload,
      networkErrorMessage:
        'Não foi possível criar a pausa. Verifique se o backend está disponível.',
      requestErrorMessage: 'Não foi possível criar a pausa agora.',
    }
  );
}

export async function updateBusinessBreakRequest(
  token: string,
  businessId: number,
  breakKind: GeneratedBreakKind,
  breakId: number,
  breakPayload: GeneratedUpdateBusinessBreakRequest
): Promise<GeneratedUpdateBusinessBreakResponse> {
  return performAuthorizedRequest<GeneratedUpdateBusinessBreakResponse>(
    token,
    {
      ...UPDATE_BUSINESS_BREAK_OPERATION,
      path: replacePathParams(UPDATE_BUSINESS_BREAK_OPERATION.path, {
        business_id: businessId,
        kind: breakKind,
        id: breakId,
      }),
    },
    {
      body: breakPayload,
      networkErrorMessage:
        'Não foi possível atualizar a pausa. Verifique se o backend está disponível.',
      requestErrorMessage: 'Não foi possível atualizar a pausa agora.',
    }
  );
}

export async function deleteBusinessBreakRequest(
  token: string,
  businessId: number,
  breakKind: GeneratedBreakKind,
  breakId: number
) {
  await performAuthorizedRequest(
    token,
    {
      ...DELETE_BUSINESS_BREAK_OPERATION,
      path: replacePathParams(DELETE_BUSINESS_BREAK_OPERATION.path, {
        business_id: businessId,
        kind: breakKind,
        id: breakId,
      }),
    },
    {
      networkErrorMessage:
        'Não foi possível eliminar a pausa. Verifique se o backend está disponível.',
      requestErrorMessage: 'Não foi possível eliminar a pausa agora.',
    }
  );
}

